import { PageDataHandler } from "@/lib/utility/data/page-data-handler";
import { ISignDocument, SignDocument } from "@/models/sign-document.entity";
import { SignDocumentControllerFindAllParamsGen } from "@/services/sign/v1/data-contracts";
import store from "@/store/VuexPlugin";
import { PaginatedBaseStore } from "../paginated-base.store";
import { SignDocumentDataAccessLayer } from "./access-layers/sign-document.access-layer";
import { PaginationFilterListElement } from "./base-pagination.store";
import { SignDocumentPageDataProvider } from "./page-data-provider/sign-document.page-data-provider";
import { Module, getModule } from "vuex-module-decorators";

@Module({
  dynamic: true,
  namespaced: true,
  name: "report-fleet-sign-document",
  store
})
export class ReportFleetSignDocumentStore extends PaginatedBaseStore<
  ISignDocument,
  SignDocumentControllerFindAllParamsGen
> {
  _data = SignDocumentDataAccessLayer;
  _pageProvider = SignDocumentPageDataProvider;
  _pager = new PageDataHandler(this._data, this._pageProvider);

  filterOptions: PaginationFilterListElement[] = SignDocument.filterables;
}

export const ReportFleetSignDocumentModule = getModule(ReportFleetSignDocumentStore);
